import React, { useState, useEffect } from "react";
import PersonalInformation from "./PersonalInformation";
import { globalFileServer } from "../../../axiosInstance";
import AddressShipping from "../addressShipping/AddressShipping";
import { useSelector } from "react-redux";

const PrivateArea = ({ parent, setSelectedAddres }) => {
  const user = useSelector((state) => state.user.user);
  const [_selectedSection, setSelectedSectionFromProps] = useState("none");
  useEffect(() => {
    setSelectedSectionFromProps(parent);
  }, [parent, setSelectedSectionFromProps]);
  return (
    <div>
      <div className="private-area">
        {parent === "cart" ? (
          <h1 className="head-page">סיום קניה ותשלום</h1>
        ) : (
          <div className="head">
            <img
              loading="lazy"
              src={globalFileServer + "iconcss/privateArea.svg"}
              alt="close"
            />
            <h1 className="head-page">
              האזור האישי של {user.Name} {user.LastName}
            </h1>
          </div>
        )}
        <PersonalInformation parent={parent} />
        <AddressShipping
          setSelectedAddres={setSelectedAddres}
          parent="private-area"
        />
        {/*parent === "cart" && <DeliveryTime />*/}
      </div>
    </div>
  );
};

export default PrivateArea;
